module.exports = __webpack_public_path__ + "img/home_french.6d5513de.webp";